export default "__VITE_ASSET__X$pZ8Ygb__"